import { render } from "./userCenter.vue?vue&type=template&id=ce9a9b84&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"

import "./userCenter.vue?vue&type=style&index=0&id=ce9a9b84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9a9b84"]])

export default __exports__